import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  imports: [],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent implements OnInit {
  private route = inject(ActivatedRoute);

  public targetOpeningTime: string = '稍後';
  public customerServicePhone: string = '02-412-8006';

  ngOnInit(): void {
    // 從路由取得維護時間參數
    this.route.queryParams.subscribe(params => {
      const { month, day, hour, minute } = params;
      
      if (month && day) {
        // 格式化顯示文字，例如：5月27號 17點00分
        const h = hour ? `${hour}點` : '00點';
        const min = minute ? `${minute}分` : '00分';
        this.targetOpeningTime = `${month}月${day}號 ${h}${min}`;
      }
    });
  }
}
